import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import cls from './InstallFloat.module.scss'
import { Button } from 'shared/ui/Button'
import logo from 'shared/assets/MineCards-Logo-Rounded.svg'
import React from 'react'
import { IconBadge, InstallIcon } from 'shared/ui/Icon'

export const InstallFloat = (props) => {
    const { closeInstallFloat, onInstall, open = true } = props

    return (
        <BottomSheet
            label="Установить MineCards"
            onOpenChange={(open) => !open && closeInstallFloat()}
            open={open}
        >
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon}>
                    <InstallIcon />
                </IconBadge>
            </div>
            <Text
                className={cls.TitleTextFloat}
                size={TextSize.XL}
                align={TextAlign.LEFT}
                weight={TextWeight.BOLD}
            >
                Воспользуйся всеми функциями приложения!
            </Text>
            <Text
                className={cls.TextFloat}
                align={TextAlign.LEFT}
                weight={TextWeight.MED}
            >
                Приложение удобнее, быстрее и в нём больше полезного
            </Text>
            <Button
                onClick={onInstall}
                className={cls.FloatButton}
                text={'Установить MineCards'}
            />
        </BottomSheet>
    )
}
